var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fingerVisible),expression:"fingerVisible"}],staticClass:"storefront-finger",class:{ 'storefront-finger--down': _vm.fingerDown },style:(_vm.fingerStyle),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }